"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Parallax = __importStar(require("react-parallax"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var es_cookie_1 = require("es-cookie");
var condo_brain_1 = require("condo-brain");
var Parking_1 = __importDefault(require("./Parking"));
var Home_1 = __importDefault(require("./Home"));
var Admin_1 = __importDefault(require("./Admin"));
var Authenticate_1 = __importDefault(require("./Authenticate"));
var Reservation_1 = __importDefault(require("./Reservation"));
var ElevatorBooking_1 = __importDefault(require("./ElevatorBooking"));
var Login_1 = __importDefault(require("./Login"));
var Nav_1 = __importDefault(require("./Nav"));
var MyReservations_1 = __importDefault(require("./MyReservations"));
require("./styles/application.scss");
var ArrowLofts_White_svg_1 = __importDefault(require("./images/ArrowLofts-White.svg"));
var Arrow_Lofts_Rendering_jpg_1 = __importDefault(require("./images/Arrow-Lofts-Rendering.jpg"));
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        display: 'flex',
    },
    toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1) }, theme.mixins.toolbar),
    content: {
        flexGrow: 1,
    },
}); });
function App() {
    var userManager = react_1.default.useState(new condo_brain_1.UserManager())[0];
    var _a = react_1.default.useState(false), auth = _a[0], setAuth = _a[1];
    var _b = react_1.default.useState(undefined), rootState = _b[0], setRootState = _b[1];
    var _c = react_1.default.useState(undefined), toolbarState = _c[0], setToolbarState = _c[1];
    var _d = react_1.default.useState(undefined), contentState = _d[0], setContentState = _d[1];
    var classes = useStyles();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    var checkLogin = function () {
        var token = (0, es_cookie_1.get)('token');
        if (token) {
            userManager.validateToken(token).then(function (_result) {
                if (userManager.loggedIn) {
                    setAuth(true);
                    setRootState(classes.root);
                    setToolbarState(classes.toolbar);
                    setContentState(classes.content);
                    if (location.pathname === '/') {
                        navigate('/reservation');
                    }
                }
                else {
                    setAuth(false);
                    setRootState(undefined);
                    setToolbarState(undefined);
                    setContentState(undefined);
                }
            });
        }
    };
    react_1.default.useEffect(function () {
        if (!userManager) {
            return;
        }
        checkLogin();
        var timer = setTimeout(function () {
            checkLogin();
            clearTimeout(timer);
        }, 1000);
    }, [auth]);
    return (react_1.default.createElement("div", { className: "App" },
        react_1.default.createElement("div", { className: rootState },
            react_1.default.createElement(CssBaseline_1.default, null),
            react_1.default.createElement(Nav_1.default, { userManager: userManager }),
            react_1.default.createElement("main", { className: contentState },
                react_1.default.createElement("div", { className: toolbarState }),
                react_1.default.createElement(Parallax.Parallax, { bgImage: Arrow_Lofts_Rendering_jpg_1.default, className: "index-banner" },
                    react_1.default.createElement("div", { className: "section no-pad-bot" },
                        react_1.default.createElement("div", { className: "container" },
                            react_1.default.createElement("h1", { className: "header center arrow-green" },
                                react_1.default.createElement("a", { id: "logo-container", href: "/", className: "brand-logo" },
                                    react_1.default.createElement("img", { alt: "Arrow Lofts", title: "Arrow Lofts", className: "arrow-logo", src: ArrowLofts_White_svg_1.default })))))),
                react_1.default.createElement("div", { className: "container" },
                    react_1.default.createElement(react_router_dom_1.Routes, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(Home_1.default, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/parking", element: react_1.default.createElement(Parking_1.default, { userManager: userManager }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "admin", element: react_1.default.createElement(Admin_1.default, { userManager: userManager }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "login", element: react_1.default.createElement(Login_1.default, { userManager: userManager }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "authenticate/:emailtoken", element: react_1.default.createElement(Authenticate_1.default, { userManager: userManager }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "reservation", element: react_1.default.createElement(Reservation_1.default, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "elevator-booking", element: react_1.default.createElement(ElevatorBooking_1.default, { userManager: userManager }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "myreservations", element: react_1.default.createElement(MyReservations_1.default, { userManager: userManager }) }))),
                react_1.default.createElement("footer", { className: "page-footer arrow-background-grey" },
                    react_1.default.createElement("div", { className: "container section flex-grow" },
                        react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                                react_1.default.createElement("h5", { className: "white-text" }, "Arrow Lofts"),
                                react_1.default.createElement("p", { className: "grey-text text-lighten-4" },
                                    "112 Benton Street",
                                    react_1.default.createElement("br", null),
                                    "Kitchener, Ontario N2G 3H6"),
                                react_1.default.createElement("p", { className: "grey-text text-lighten-4" }, "A beautiful home in a beautiful city.")),
                            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                                react_1.default.createElement("h5", { className: "white-text" }, "Additional Resources"),
                                react_1.default.createElement("ul", null,
                                    react_1.default.createElement("li", null,
                                        react_1.default.createElement("a", { className: "white-text", href: "https://condocontrolcentral.com/login" }, "Condo Control Central")),
                                    react_1.default.createElement("li", null,
                                        react_1.default.createElement("a", { className: "white-text", href: "https://www.kitchener.ca/" }, "City of Kitchener")),
                                    react_1.default.createElement("li", null,
                                        react_1.default.createElement("a", { className: "white-text", href: "https://www.kitchener.ca/en/getting-around/parking.aspx" }, "Kitchener Parking Information")))))),
                    react_1.default.createElement("div", { className: "footer-copyright" },
                        react_1.default.createElement("div", { className: "container" },
                            react_1.default.createElement("a", { className: "white-text", href: "https://github.com/condomanagement" },
                                "Open Source and Built with",
                                react_1.default.createElement("span", { role: "img", "aria-label": "love" }, "\u2764\uFE0F "),
                                "by David"))))))));
}
exports.default = App;
